import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72b4e637&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=72b4e637&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b4e637",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/usedcar-vue-mobile-uat-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b4e637')) {
      api.createRecord('72b4e637', component.options)
    } else {
      api.reload('72b4e637', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72b4e637&scoped=true", function () {
      api.rerender('72b4e637', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/svgIcon/index.vue"
export default component.exports